import { useI18n } from '../i18n';
import { track } from '../lib/analytics';

const IOS_URL = 'https://apps.apple.com/tr/app/sudoku-area/id6768587148?l=tr';
const ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.sudokuarea.app';

export function AppleLogo() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.7 9.05 7.42c1.27.07 2.14.82 2.88.84.85 0 2.45-.98 4.12-.83 1.74.17 2.96.89 3.79 2.02-3.41 2.04-2.85 6.52.57 7.89-.45 1.08-.93 2.14-1.36 2.94zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
    </svg>
  );
}

export function GooglePlayLogo() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M3 1.6v20.8L13.8 12z" fill="#4285F4"/>
      <path d="M13.8 12L3 1.6l15.1 8.7z" fill="#EA4335"/>
      <path d="M13.8 12L3 22.4l15.1-8.7z" fill="#34A853"/>
      <path d="M18.1 10.3L13.8 12l4.3 1.7L21 12z" fill="#FBBC04"/>
    </svg>
  );
}

interface Props {
  label?: string;
}

export function AppStoreBadges({ label }: Props) {
  const { t } = useI18n();
  return (
    <div className="app-store-badges">
      {label && <span className="app-store-badges-label">{label}</span>}
      <div className="app-store-badges-row">
        <a
          href={IOS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="app-store-icon-btn"
          aria-label={t.common.downloadAppStore}
          onClick={() => track('store_click', { store: 'ios', placement: 'store_badge' })}
        >
          <AppleLogo />
        </a>
        <a
          href={ANDROID_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="app-store-icon-btn"
          aria-label={t.common.downloadGooglePlay}
          onClick={() => track('store_click', { store: 'android', placement: 'store_badge' })}
        >
          <GooglePlayLogo />
        </a>
      </div>
    </div>
  );
}
